import { render, staticRenderFns } from "./HeroAlt.vue?vue&type=template&id=ca35a38a&"
import script from "./HeroAlt.vue?vue&type=script&lang=js&"
export * from "./HeroAlt.vue?vue&type=script&lang=js&"
import style0 from "./HeroAlt.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VBreadcrumbs,VCol,VRow,VThemeProvider})
